import React from "react";
import { Icon, Table } from "dyl-components";
import { Table as SemanticTable } from "semantic-ui-react";
import { useNavigate, useSearchParams } from "react-router-dom";

import { useSelector } from "react-redux";
import SelectAllCheckbox from "shared/SelectAllCheckbox";
import {
    KEY_ACCOUNT_CO_OWNER,
    KEY_ACCOUNT_NAME,
    KEY_OPPORTUNITY_OUTCOME,
    KEY_ACCOUNT_STATUS,
    KEY_ACCOUNT_OWNER,
    KEY_CONTACT_CO_OWNER,
    KEY_CONTACT_NAME,
    KEY_CONTACT_OWNER,
    KEY_CREATED,
    KEY_CREATED_BY,
    KEY_EXPIRES_ON,
    KEY_LAST_MODIFIED,
    KEY_LAST_MODIFIED_BY,
    KEY_NUMBER_PRODUCTS,
    KEY_OPPORTUNITY_NAME,
    KEY_PRODUCTS,
    KEY_PROPOSAL_INVOICE_CREATED,
    KEY_STATUS,
    KEY_SUBTOTAL,
} from "shared/constants/QUOTES_ORDERS_COLUMNS";

const SortActions = ({ direction = false, onToggleSort = () => {} }) => {
    return (
        <div
            onClick={onToggleSort}
            style={{ display: "inline-flex", cursor: "pointer" }}
        >
            <Icon
                name="fa-solid fa-arrow-down-long"
                style={{
                    marginRight: -7,
                    opacity: !direction ? "100%" : "50%",
                }}
            />
            <Icon
                name="fa-solid fa-arrow-up-long"
                style={{ opacity: direction ? "100%" : "50%" }}
            />
        </div>
    );
};

export const QuotesAndOrdersHeader = ({ isColumnHidden }) => {
    const [params] = useSearchParams();
    const navigate = useNavigate();

    const createdOrder =
        params.get("sort_by") === "created" && params.get("sort") === "asc";
    const lastModifiedOrder =
        params.get("sort_by") === "last_modified" && params.get("sort") === "asc";
    const proposalInvoiceCreatedOrder =
        params.get("sort_by") === "proposal_invoice_created" &&
        params.get("sort") === "asc";
    const expiresOnOrder =
        params.get("sort_by") === "expires_on" &&
        params.get("sort") === "asc";

    const createdOrderFilter = () => {
        const query = new URLSearchParams(params);
        const order = !createdOrder ? "asc" : "desc";
        query.set("sort", order);
        query.set("sort_by", "created");
        const query_string = query.toString();
        navigate(`/settings/quotes-orders${query_string ? `?${query_string}` : ""}`);
    };

    const lastModifiedOrderFilter = () => {
        const query = new URLSearchParams(params);
        const order = !lastModifiedOrder ? "asc" : "desc";
        query.set("sort", order);
        query.set("sort_by", "last_modified");
        const query_string = query.toString();
        navigate(`/settings/quotes-orders${query_string ? `?${query_string}` : ""}`);
    };

    const proposalInvoiceCreatedOrderFilter = () => {
        const query = new URLSearchParams(params);
        const order = !lastModifiedOrder ? "asc" : "desc";
        query.set("sort", order);
        query.set("sort_by", "proposal_invoice_created");
        const query_string = query.toString();
        navigate(`/settings/quotes-orders${query_string ? `?${query_string}` : ""}`);
    };

    const expiresOnOrderFilter = () => {
        const query = new URLSearchParams(params);
        const order = !lastModifiedOrder ? "asc" : "desc";
        query.set("sort", order);
        query.set("sort_by", "expires_on");
        const query_string = query.toString();
        navigate(`/settings/quotes-orders${query_string ? `?${query_string}` : ""}`);
    };

    const { count, quotesAndOrders = [] } = useSelector((state) => {
        return {
            count: 0,
            quotesAndOrders: [],
        };
    });

    return (
        <Table.Row>
            <SemanticTable.HeaderCell
                width={1}
                className="QuotesAndOrdersTable__SmallFixedWidth"
            >
                <SelectAllCheckbox
                    count={count}
                    data={quotesAndOrders}
                    type={"quotes and orders"}
                    idProperty={"id"}
                />
            </SemanticTable.HeaderCell>
            {!isColumnHidden(KEY_CREATED) && (
                <SemanticTable.HeaderCell
                    className="QuotesAndOrdersTable__MediumFixedWidth"
                    width={2}
                >
                    Created
                    <SortActions
                        direction={createdOrder}
                        onToggleSort={() => {
                            createdOrderFilter();
                        }}
                    />
                </SemanticTable.HeaderCell>
            )}
            {!isColumnHidden(KEY_LAST_MODIFIED) && (
                <SemanticTable.HeaderCell
                    className="QuotesAndOrdersTable__MediumFixedWidth"
                    width={2}
                >
                    Last Modified
                    <SortActions
                        direction={lastModifiedOrder}
                        onToggleSort={() => {
                            lastModifiedOrderFilter();
                        }}
                    />
                </SemanticTable.HeaderCell>
            )}
            {!isColumnHidden(KEY_PROPOSAL_INVOICE_CREATED) && (
                <SemanticTable.HeaderCell
                    className="QuotesAndOrdersTable__LargeFixedWidth"
                    width={2}
                >
                    Proposal/Invoice Created
                    <SortActions
                        direction={proposalInvoiceCreatedOrder}
                        onToggleSort={() => {
                            proposalInvoiceCreatedOrderFilter();
                        }}
                    />
                </SemanticTable.HeaderCell>
            )}
            {!isColumnHidden(KEY_EXPIRES_ON) && (
                <SemanticTable.HeaderCell
                    className="QuotesAndOrdersTable__MediumFixedWidth"
                    width={2}
                >
                    Expires On
                    <SortActions
                        direction={expiresOnOrder}
                        onToggleSort={() => {
                            expiresOnOrderFilter();
                        }}
                    />
                </SemanticTable.HeaderCell>
            )}
            <SemanticTable.HeaderCell
                className="QuotesAndOrdersTable__MediumFixedWidth"
                width={3}
            >
                ID
            </SemanticTable.HeaderCell>
            {!isColumnHidden(KEY_NUMBER_PRODUCTS) && (
                <SemanticTable.HeaderCell
                    className="QuotesAndOrdersTable__MediumFixedWidth"
                    width={2}
                >
                    # Products
                </SemanticTable.HeaderCell>
            )}
            {!isColumnHidden(KEY_PRODUCTS) && (
                <SemanticTable.HeaderCell
                    className="QuotesAndOrdersTable__MediumFixedWidth"
                    width={2}
                >
                    Products
                </SemanticTable.HeaderCell>
            )}
            {!isColumnHidden(KEY_CONTACT_OWNER) && (
                <SemanticTable.HeaderCell
                    className="QuotesAndOrdersTable__MediumFixedWidth"
                    width={2}
                >
                    Contact Owned By
                </SemanticTable.HeaderCell>
            )}
            {!isColumnHidden(KEY_CONTACT_CO_OWNER) && (
                <SemanticTable.HeaderCell
                    className="QuotesAndOrdersTable__MediumFixedWidth"
                    width={2}
                >
                    Contact Co-Owned By
                </SemanticTable.HeaderCell>
            )}
            {!isColumnHidden(KEY_ACCOUNT_OWNER) && (
                <SemanticTable.HeaderCell
                    className="QuotesAndOrdersTable__MediumFixedWidth"
                    width={2}
                >
                    Account Owned By
                </SemanticTable.HeaderCell>
            )}
            {!isColumnHidden(KEY_ACCOUNT_CO_OWNER) && (
                <SemanticTable.HeaderCell
                    className="QuotesAndOrdersTable__MediumFixedWidth"
                    width={2}
                >
                    Account Co-Owned By
                </SemanticTable.HeaderCell>
            )}
            {!isColumnHidden(KEY_CONTACT_NAME) && (
                <SemanticTable.HeaderCell
                    className="QuotesAndOrdersTable__LargeFixedWidth"
                    width={4}
                >
                    Contact Name
                </SemanticTable.HeaderCell>
            )}
            {!isColumnHidden(KEY_ACCOUNT_NAME) && (
                <SemanticTable.HeaderCell
                    className="QuotesAndOrdersTable__LargeFixedWidth"
                    width={4}
                >
                    Account Name
                </SemanticTable.HeaderCell>
            )}
            {!isColumnHidden(KEY_OPPORTUNITY_NAME) && (
                <SemanticTable.HeaderCell
                    className="QuotesAndOrdersTable__MediumFixedWidth"
                    width={3}
                >
                    Opportunity Name
                </SemanticTable.HeaderCell>
            )}
            {!isColumnHidden(KEY_CREATED_BY) && (
                <SemanticTable.HeaderCell
                    className="QuotesAndOrdersTable__MediumFixedWidth"
                    width={2}
                >
                    Created By
                </SemanticTable.HeaderCell>
            )}
            {!isColumnHidden(KEY_LAST_MODIFIED_BY) && (
                <SemanticTable.HeaderCell
                    className="QuotesAndOrdersTable__MediumFixedWidth"
                    width={2}
                >
                    Last Modified By
                </SemanticTable.HeaderCell>
            )}
            {!isColumnHidden(KEY_OPPORTUNITY_OUTCOME) && (
                <SemanticTable.HeaderCell
                    className="QuotesAndOrdersTable__MediumFixedWidth"
                    width={3}
                >
                    Opportunity Outcome
                </SemanticTable.HeaderCell>
            )}
            {!isColumnHidden(KEY_ACCOUNT_STATUS) && (
                <SemanticTable.HeaderCell
                    className="QuotesAndOrdersTable__MediumFixedWidth"
                    width={3}
                >
                    Account Status
                </SemanticTable.HeaderCell>
            )}
            {!isColumnHidden(KEY_SUBTOTAL) && (
                <SemanticTable.HeaderCell
                    className="QuotesAndOrdersTable__MediumFixedWidth"
                    width={2}
                >
                    Subtotal
                </SemanticTable.HeaderCell>
            )}
            {!isColumnHidden(KEY_STATUS) && (
                <SemanticTable.HeaderCell
                    className="QuotesAndOrdersTable__MediumFixedWidth"
                    width={3}
                >
                    Status
                </SemanticTable.HeaderCell>
            )}
        </Table.Row>
    );
};
